import { Address } from '@scts/models';
import { AddressLineFormatter } from '@scts/utilities';
import { FormHeader, FormItem } from '@scts-ui/component-library';

export interface AddressProps {
  address: Address;
}

const AddressComponent = (addressProps: AddressProps) => {
  const formattedAddress =
    addressProps.address.addressLine1 +
    AddressLineFormatter(addressProps.address.addressLine2) +
    AddressLineFormatter(addressProps.address.addressLine3) +
    AddressLineFormatter(addressProps.address.townCity) +
    AddressLineFormatter(addressProps.address.postalCode);

  return (
    <div className="card-body details-address">
      <FormHeader detail={'Address: '} />
      <FormItem
        header={'Address: '}
        detail={formattedAddress}
        minWidthHeader={'9.7rem'}
        minWidthDetail={'9.7rem'}
      />
    </div>
  );
};

export default AddressComponent;
